package com.shadowings.gero.data.lessons.chapter3
import com.shadowings.gero.data.lessons.calculateDirectGenitivePhrases


import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TextTranslationContent
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.*

fun getGenitivoDiretto2Content(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_genitivo_diretto_ii,
            content = Res.string.exp_content_continuiamo_con_esercizi_sul_genitivo_diretto,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_diretto_ii,
            content = Res.string.exp_content_questa_volta_sar_un_po_pi_difficile,
            face = Faces.Serious
        ),
        ExplanationContent(
            title = Res.string.exp_title_genitivo_diretto_ii,
            content = Res.string.exp_content_fai_attenzione_a_genere_e_numero_mi_raccomand,
            face = Faces.Happy
        ),
        ExplanationContent(
            title = Res.string.exp_title_lezione_completata,
            content = Res.string.exp_content_andiamo,
            face = Faces.Perfect
        )
    )
}

fun getGenitivoDiretto2QuizContent(words: List<Word>, languageCode: String): List<IQuizContent> {
    val validPairs = listOf(
        Pair("TORO", "SACERDOTE"),
        Pair("PESCE", "PADRE"),
        Pair("PADRE", "SACERDOTE"),
        Pair("GATTO", "UOMO"),
        Pair("MUCCA", "PASTORE"),
        Pair("MUCCHE", "PADRE"),
        Pair("ACQUA", "SACERDOTE"),
        Pair("VINO", "DONNA"),
        Pair("FALCO", "PASTORI"),
        Pair("BIRRA", "SCRIBA"),
        Pair("PANE", "UOMO"),
        Pair("GRANO", "SACERDOTE"),
        Pair("ALBERI", "MADRE"),
        Pair("FALCHI", "PADRE"),
        Pair("UCCELLO", "PASTORE"),
        Pair("INCENSO", "SACERDOTI")
    )

    val phrases = calculateDirectGenitivePhrases(words, validPairs, 15, languageCode)
    return phrases.map { phrase ->
        TextTranslationContent(
            hieroglyphs = phrase.hieroglyphs,
            correctPhrase = phrase.correctPhrase,
            transliteration = "${phrase.word1.reading} ${phrase.word2.reading}"
        )
    }
}
